export const VIEW_ALL_TILE_IDENTIFIER = 'VIEW_ALL';
export const MANAGED_WAREHOUSE_TILE_IDENTIFIER = 'MANAGED_BIGQUERY';

export const VIEW_ALL_TILE_CONFIG = {
  id: VIEW_ALL_TILE_IDENTIFIER,
  thumbnail:
    'https://res.cloudinary.com/hevo/image/upload/v1649740688/glyphs/dashboard-view-all-light-mode_lbrpk8.svg',
  darkModeThumbnail:
    'https://res.cloudinary.com/hevo/image/upload/v1649740688/glyphs/dashboard-view-all-dark-mode_hhky2z.svg',
  title: 'View All Destination Types',
  data: {
    dest_type: VIEW_ALL_TILE_IDENTIFIER
  },
  metaData: {
    primaryColor: '#374053',
    darkModePrimaryColor: '#FFFFFF'
  }
};

export const MANAGED_WAREHOUSE_TILE_CONFIG = {
  id: MANAGED_WAREHOUSE_TILE_IDENTIFIER,
  thumbnail: 'https://cdn.hevodata.com/external_logos/managed-bigquery.svg',
  darkModeThumbnail: 'https://cdn.hevodata.com/external_logos/managed-bigquery.svg',
  title: 'Managed Warehouse',
  data: {
    dest_type: MANAGED_WAREHOUSE_TILE_IDENTIFIER,
    dest_type_display: 'Managed BigQuery Warehouse',
    dest_type_description: ''
  },
  metaData: {
    primaryColor: 'rgb(59, 149, 212)',
    darkModePrimaryColor: '#66A2DF'
  }
};
